import React, { ChangeEvent, useMemo } from 'react';

import { Icon } from '../../Icon';

import './styles.scss';

interface Props {
    value: string;
    minValue?: string;
    maxValue?: string;
    className?: string;
    disabled?: boolean;
    error?: string;
    onChange: (value: string) => void;
}

export const NumberInput = ({ value, className = '', minValue, maxValue, disabled, error, onChange }: Props) => {
    const isDecreaseButtonDisabled = useMemo(() => disabled || value === minValue, [disabled, value, minValue]);
    const isIncreaseButtonDisabled = useMemo(() => disabled || value === maxValue, [disabled, value, maxValue]);

    const decrement = (): void => {
        onChange(String(parseInt(value) - 1));
    };

    const increment = (): void => {
        onChange(String(parseInt(value) + 1));
    };

    const onInputChange = (e: ChangeEvent<HTMLInputElement>) => {
        onChange(e.target.value);
    };

    const onBlur = () => {
        if (minValue && (!value || parseInt(value) < parseInt(minValue))) {
            onChange(minValue);
            return;
        }

        if (maxValue && parseInt(value) > parseInt(maxValue)) {
            onChange(maxValue);
            return;
        }
    };

    return (
        <div className={`app-number-input ${className}`}>
            <div className='app-number-input__wrap'>
                <button className='app-number-input__button' disabled={isDecreaseButtonDisabled} onClick={decrement}>
                    <Icon icon='minus-solid' size='12' />
                </button>
                <input
                    type='number'
                    inputMode='decimal'
                    className={`app-number-input__input ${error ? 'app-number-input__input--has-error' : ''}`}
                    value={value}
                    disabled={disabled}
                    autoComplete='off'
                    onChange={onInputChange}
                    onBlur={onBlur}
                />
                <button className='app-number-input__button' disabled={isIncreaseButtonDisabled} onClick={increment}>
                    <Icon icon='plus-solid' size='12' />
                </button>
            </div>
            {!!error && <span className='app-number-input__error-message'>{error}</span>}
        </div>
    );
};
